import { Navigate, Outlet } from "react-router-dom"
import AgeAuthentication from "../pages/ageauthentication"
import { useState } from "react"
import Home from "../pages/home"

const AgeVerification = ({storageAccessed, verified, setVerified, mocktails, setMocktails}) => {
    // return verified ? <Outlet /> : <Navigate to="/verify" />
    return mocktails || verified ? <Outlet /> : <AgeAuthentication setVerified={setVerified} setMocktails={setMocktails}/>

}

export default AgeVerification